import styled from 'styled-components';

export const SafetyAuditsContent = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: var(--space-xxxxl);

  padding: var(--space-xxxl) 0 var(--space-xxxxl);

  @media screen and (max-width: 950px) {
    gap: var(--space-xxxl);
    padding: var(--space-xxl) 0 var(--space-xxxl);
  }

  @media screen and (max-width: 600px) {
    gap: var(--space-xxl);
    padding: var(--space-xl) 0 var(--space-xxl);
  }
`;
